import React from 'react';
import PropTypes from 'prop-types';
import Link from '../common/Link';
import ForthcomingItem from './ForthcomingItem';
import ForthcomingItemLoading from './ForthcomingItemLoading';
import InterestModal from './InterestModal';

export default class Forthcoming extends React.Component {
  static propTypes = {
    developments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
      })
    ),
    error: PropTypes.bool,
  };

  state = {};

  openDetailsModal = (developmentId, development) => {
    this.setState({
      showModal: true,
      developmentId,
      development,
    });
  };

  closeDetailsModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    if (!this.props.developments && this.props.error) {
      return (
        <div className="container">
          <p>An error occurred while trying to load developments, please try again later.</p>
        </div>
      );
    }
    if (this.props.developments && this.props.developments.length === 0) {
      return (
        <section className="list container">
          <p>There are currently no forthcoming developments on the website.</p>
          <p>
            <Link to="/developments">Click here</Link> to view our current developments, or check
            back later.
          </p>
        </section>
      );
    }
    return (
      <section className="list container">
        <InterestModal
          developmentId={this.state.developmentId}
          development={this.state.development}
          onClose={this.closeDetailsModal}
          open={this.state.showModal}
        />
        <div className="auto-clear row-flex row-flex-wrap">
          {this.props.developments
            ? this.props.developments.map((development) => (
                <ForthcomingItem
                  key={development.id}
                  onInterestModal={this.openDetailsModal}
                  {...development}
                />
              ))
            : [0, 1, 2].map((key) => <ForthcomingItemLoading key={key} />)}
        </div>
      </section>
    );
  }
}
